import { render } from "./PoojaCart.vue?vue&type=template&id=383d488c"
import script from "./PoojaCart.vue?vue&type=script&lang=js"
export * from "./PoojaCart.vue?vue&type=script&lang=js"

import "./PoojaCart.vue?vue&type=style&index=0&id=383d488c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__